import * as React from 'react';
import { EngineRenderers } from '@websky/core/src/renderProps';
import ImageWithFallback from '@websky/core/src/ImageWithFallback';

const FlightInfoIcon: EngineRenderers['renderFlightInfoIcon'] = props => {
	return <ImageWithFallback {...props} fallbackSrc={null} />;
};

export default FlightInfoIcon;
